(() => {
    if (!$) {
        return;
    }

    const up = document.querySelector('.j-up-button');

    if (up) {
        const check = () => {
            if ($('html, body')
                .scrollTop() <= 200) {
                up.style.display = 'none';
            } else {
                up.style.display = 'flex';
            }
        };

        check();

        up.addEventListener('click', () => {
            $('html, body')
                .animate({scrollTop: 0}, 'slow');
        });

        window.addEventListener('scroll', () => {
            check();
        });
    }
})();
